<button class="app-sidebar-content-header" [kitModel]="summaryHeaderToggle"></button>
<app-time-recording-summary [kitModel]="model.summary" class="app-sidebar-content" *ngIf="model.summaryExpanded"></app-time-recording-summary>

<button class="app-sidebar-content-header" [kitModel]="workingHoursHeaderToggle"></button>
<kit-container [kitModel]="model.workingHours" class="app-sidebar-content" *ngIf="model.workingHoursExpanded"></kit-container>
